// @ts-nocheck

import { reduce as _reduce, size as _size } from 'lodash';

import { BasketModes, BasketStatuses, BasketItemStatuses } from '../../../types/basket';
import { basket as BasketUtils } from '../../../utils';
import recomputeBasketStateForOperations from '../utils/recomputeBasketStateForOperations';

const { formatStake, generateSystems, getMode } = BasketUtils;

const delItem = (state, action, { entities }) => {
  const { mode, items, stake, defaultStake, freebets, selectedFreebetId } = state;

  let nextStake = stake || defaultStake;
  const { oddId, keepStake } = action.payload;
  if (items[oddId] !== undefined) {
    // NOTE: reset error message, betslip id, additional message
    // NOTE: remove all items validated or waiting
    // NOTE: remove item selected
    const nextItems = _reduce(
      items,
      (finalItems, item) => {
        const { status: itemStatus, oddId: itemId } = item;
        if (
          itemStatus !== BasketItemStatuses.VALIDATED &&
          itemStatus !== BasketItemStatuses.WAITING &&
          itemId !== oddId
        ) {
          return {
            ...finalItems,
            [itemId]: {
              ...item,
              status: BasketItemStatuses.OK,
              betslipId: undefined,
              error: undefined,
              additionalMessage: undefined,
            },
          };
        }
        return finalItems;
      },
      {},
    );

    /* FIXME freebets and boosters */

    const { matches } = entities;
    /* recompute the mode */
    const nextMode = getMode(mode, nextItems, { matches });

    if (nextMode === BasketModes.COMBINED) {
      if (selectedFreebetId) {
        const freebet = freebets[selectedFreebetId];
        if (freebet !== undefined) {
          const { amount } = freebet;
          nextStake = amount / 100;
        } else {
          nextStake = defaultStake;
        }
      }
    }

    let nextSystems = undefined;
    if (nextMode === BasketModes.SYSTEM) {
      nextSystems = generateSystems({ items: nextItems });
    }

    if (!keepStake && _size(nextItems) === 0) {
      nextStake = '';
    }

    return {
      ...state,
      status: BasketStatuses.OK,
      mode: nextMode,
      items: nextItems,
      systems: nextSystems,
      stake: formatStake(nextStake),
      error: undefined,
      additionalMessage: undefined,
      betslipId: undefined,
      isFromLineUp: Object.keys(nextItems).some((key) => nextItems[key].isFromLineUp),
    };
  }

  return state;
};

/**
 * Return the nextState corresponding to the BASKET_DEL_ITEM action
 *
 * @param  {Object} basketState      The actual basket state.
 * @param  {Object} action           The action to reduce.
 * @param  {Object} options.entities The entities's state.
 * @return {Object}                  Return the new state.
 */

const basketDelItem = (basketState, action, globalState) => {
  const { status } = basketState;
  let nextState = basketState;

  if (status !== BasketStatuses.PENDING && status !== BasketStatuses.VALIDATED && status !== BasketStatuses.WAITING) {
    nextState = delItem(nextState, action, globalState);
    nextState = recomputeBasketStateForOperations(nextState, globalState);
  }

  return nextState;
};

export default basketDelItem;
